exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-6cb8ee69] {\n  color: red;\n  font-size: 0.9em;\n}\ndiv.field[data-v-6cb8ee69] {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
